export class SalesBucketReferenceModel {
    public salesBucketCode: string;
    public salesBucketName: string;
    public sortSequence: number;
}